import { WidgetSliderBlock } from './slider.block.model';
import { WidgetQuestionBlock } from './question.block.model';


export * from './slider.block.model';
export * from './question.block.model';

export type WidgetBlock = WidgetSliderBlock | WidgetQuestionBlock;
